<template>

  <div v-if="$store.getters.isAuthenticated" class="h-full">
    <Header />
    <router-view/>
    <DebugUsersSwitcher/>
  </div>

</template>

<script>
import Header from "../../components/employee/Header.vue"
import DebugUsersSwitcher from "../../components/employee/debug/DebugUsersSwitcher.vue"

export default {
  components: {
    Header,
    DebugUsersSwitcher,
  }
}
</script>
